import { Heading } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { CourseCodeError } from "../components/CourseCodeError";

const Status = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Heading border="bottom">{t("status.title")}</Heading>
      <CourseCodeError />
    </div>
  );
};

export default Status;
